import {analyticsLogEvent} from '../api'

const eventName = 'listing_img_switch'

interface Parameters {
    list: string | undefined
    productId: string
}

/**
 * Tracks a product added to cart.
 *
 * @param {Parameters} params - Object containing the product details.
 * @param {string} params.currencyCode - The currency code being used.
 * @param {string} params.list - List parameter
 * @param {Omit<ProductImpression, 'list'>} params.product - Product parameter
 */
export function analyticsEventTileImageCarouselSlideChange({list, productId}: Parameters): void {
    const eventDetails = {
        eventCategory: 'listing_img_switch',
        eventAction: list,
        eventLabel: productId,
    }

    analyticsLogEvent(eventName, eventDetails)
}
